"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicationsPage = void 0;
var react_1 = __importStar(require("react"));
var doshx_controls_web_1 = require("doshx_controls_web");
var page_path_1 = require("../components/page_path");
var get_publications_1 = require("../../../api/calls/news/get_publications");
var react_router_dom_1 = require("react-router-dom");
var PublicationsPage = function () {
    var _a = (0, react_1.useState)([]), publications = _a[0], setPublications = _a[1];
    var _b = (0, react_1.useState)(true), isLoading = _b[0], setIsLoading = _b[1];
    var navigate = (0, react_router_dom_1.useNavigate)();
    (0, react_1.useEffect)(function () {
        (0, get_publications_1.getPublications)().then(function (response) {
            var _a;
            if (response.success) {
                var tempData_1 = [];
                (_a = response === null || response === void 0 ? void 0 : response.content) === null || _a === void 0 ? void 0 : _a.forEach(function (doc) {
                    var publication = doc.data();
                    tempData_1.push({ uid: doc.id, image: publication === null || publication === void 0 ? void 0 : publication.image, name: publication === null || publication === void 0 ? void 0 : publication.name, sortOrder: publication === null || publication === void 0 ? void 0 : publication.sortOrder });
                });
                setIsLoading(false);
                setPublications(tempData_1);
            }
        });
        //
    }, []);
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "flex flex-col gap-4" },
            react_1.default.createElement(page_path_1.PagePath, { path: [
                    {
                        page: "/",
                        title: "Home",
                    },
                    {
                        page: "",
                        title: "Publications",
                        active: true,
                    },
                ] }),
            react_1.default.createElement(doshx_controls_web_1.LabelControl, { bold: true, size: "2xlarge", label: "Publications", textColor: "text-primary" }),
            isLoading ? (react_1.default.createElement(doshx_controls_web_1.ShimmerBoxControl, null)) : (publications.map(function (pub, index) {
                return (react_1.default.createElement("div", { onClick: function () {
                        navigate("/articles/".concat(pub.uid));
                    }, key: index },
                    react_1.default.createElement(doshx_controls_web_1.BoxControl, { className: "shadow hover:shadow-lg transition-shadow cursor-pointer", borderColor: "border-transparent" },
                        react_1.default.createElement("div", { key: index, className: "flex flex-row gap-4 justify-between" },
                            react_1.default.createElement("img", { className: "h-10", src: "".concat(pub.image) }),
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { className: "cursor-pointer", label: pub.name, bold: true, size: "medium", textColor: "text-black" })))));
            })))));
};
exports.PublicationsPage = PublicationsPage;
